/**
 * Native share sheet on mobile PWAs; clipboard fallback elsewhere.
 * @returns {'shared'|'copied'|'cancelled'}
 */
export async function shareContent({ title, text, url }) {
  const payload = {
    title: title || 'Prasaar',
    text: text || '',
    url: url || (typeof window !== 'undefined' ? window.location.href : ''),
  };

  if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
    try {
      await navigator.share(payload);
      return 'shared';
    } catch (err) {
      // User dismissed the sheet — not an error.
      if (err && (err.name === 'AbortError' || err.name === 'NotAllowedError')) {
        return 'cancelled';
      }
      // Fall through to clipboard.
    }
  }

  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(payload.url || payload.text || '');
    return 'copied';
  }

  throw new Error('Sharing is not supported on this device');
}

export function canUseNativeShare() {
  return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
}
